'use client'
import { useState, useEffect } from 'react'
import { useRouter } from 'next/navigation'
import { RadioGroup } from '@headlessui/react'

import { updateSearchParams, getSearchParams } from "@utils";
import { saleTypes } from '@constants/saleTypes';


const SaleFilter = ({ title, lang, dictionary }) => {
    const router = useRouter();
    // const searchParams = useSearchParams();
    let [sale, setSale] = useState(saleTypes[lang][0])
    let [addChecked, setAddChecked] = useState(saleTypes[lang][0].value)

    const handleUpdateParams = (e) => {
        const newPathname = `${window.location.pathname}?saleType=${e.value.toString()}`
        // const newPathName = updateSearchParams(title, e.value);
        // const newPathName = `${window.location.pathname}?saleType=${e.value}`
        router.push(newPathname);
        router.refresh()


    };

    useEffect(() => {
        const saleT = getSearchParams('saleType')
        setAddChecked(saleT)
        const newValue = saleTypes[lang].find(obj => obj.value === addChecked);

        if (newValue != undefined) {
            setSale(newValue)
        }
    }, [handleUpdateParams])

    return (
        <div className="w-full">
            <span className='text-maincolor text-xl pb-2'>{dictionary.typeOfTransaction}:</span>
            <div className="w-full">
                <RadioGroup value={sale} onChange={(value) => {
                    setSale(value)
                    handleUpdateParams(value)
                }}
                    className='w-full flex flex-row mt-2 rounded-lg shadow-md border-[1px] border-forth overflow-hidden'
                >
                    {saleTypes[lang].map((saleType) => (
                        <RadioGroup.Option
                            key={saleType.value}
                            value={saleType}
                            checked={saleType === sale}
                            className={({ active, checked }) =>
                                `${active
                                    ? ''
                                    : ''
                                }
                                    ${checked ? 'bg-maincolor text-light' : 'bg-light'
                                }
                                w-full relative flex cursor-pointer px-2 py-2 shadow-md focus:outline-none`
                            }
                        >
                            {({ active, checked }) => (
                                <>
                                    <div className="flex w-full items-center justify-center">
                                        <div className="flex items-center">
                                            <div className="text-sm text-center">
                                                <RadioGroup.Label
                                                    as="p"
                                                    className={`font-medium w-full  ${checked ? 'text-light' : 'text-maincolor'
                                                        }`}
                                                >
                                                    {saleType.title}
                                                </RadioGroup.Label>
                                            </div>
                                        </div>
                                    </div>
                                </>
                            )}
                        </RadioGroup.Option>
                    ))}
                </RadioGroup>
            </div>
        </div>
    )
}

export default SaleFilter